export enum EOperadorLogico {
    E = 1,
    OU = 2
}
